import React, { memo } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import DashboardIcon from '@mui/icons-material/Dashboard';
import FormatListBulletedRoundedIcon from "@mui/icons-material/FormatListBulletedRounded";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import AutoGraphRoundedIcon from "@mui/icons-material/AutoGraphRounded";
import SegmentRoundedIcon from "@mui/icons-material/SegmentRounded";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import ContactSupportRoundedIcon from "@mui/icons-material/ContactSupportRounded";
import UpdateRoundedIcon from "@mui/icons-material/UpdateRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import HandshakeIcon from "@mui/icons-material/Handshake";
import DetailsIcon from '@mui/icons-material/Details';
import TableViewIcon from '@mui/icons-material/TableView';
import EmailIcon from '@mui/icons-material/Email';

const SidebarLogo = memo(() => (
  <div className="sticky-top bg-primary" style={{ zIndex: 1020 }}>
    <img
      className="px-5 py-4"
      src="/logo.png"
      alt="Logo"
      style={{ width: "100%" }}
    />
  </div>
));

SidebarLogo.displayName = 'SidebarLogo';

const SideBar = () => {
  const location = useLocation();
  const userType = process.env.REACT_APP_USER_TYPE;

  return (
    <div
      id="sidebarContainer"
      className="vh-100 bg-primary"
      style={{
        position: "sticky",
        top: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        width: "100%"
      }}
    >
      <style>
        {`
          /* Hide scrollbar for Chrome, Safari and Opera */
          .sidenav-group::-webkit-scrollbar {
            width: 4px;
          }

          /* Track */
          .sidenav-group::-webkit-scrollbar-track {
            background: transparent; 
          }
           
          /* Handle */
          .sidenav-group::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.1); 
            border-radius: 4px;
          }

          /* Handle on hover */
          .sidenav-group::-webkit-scrollbar-thumb:hover {
            background: rgba(255, 255, 255, 0.2); 
          }
          
          /* Extend active menu items to edge */
          .nav-link.active {
            margin-right: 0;
            padding-right: 25px; /* Increase padding to ensure full width highlight */
            border-radius: 0; /* Remove border radius for flat edge on right side */
          }
          
          /* Add left padding to non-active items for alignment */
          .nav-link:not(.active) {
            margin-left: 10px;
            margin-right: 10px;
          }

          /* Ensure smooth transitions for all nav links */
          .nav-link {
            transition: background-color 0.2s ease, color 0.2s ease;
          }
        `}
      </style>
      <SidebarLogo />


      <div
        className="sidenav-group mt-3"
        style={{
          overflowY: "auto",
          overflowX: "hidden",
          maxHeight: "calc(100vh - 120px)",
          msOverflowStyle: "none",
          scrollbarWidth: "none",
          paddingLeft: "0",
          paddingRight: "0"
        }}
      >
        <div className="nav flex-column nav-pills" style={{ width: "100%" }}>
          {userType === "ADMIN" && (
            <Link
              to="/admin/dashboard"
              className={
                "nav-link sidenav-item text-white fs-large-regular text-start w-100 " +
                (location.pathname === "/admin/dashboard"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular")
              }
              type="button"
              role="tab"
              aria-selected="false"
              style={{ position: "relative" }}
            >
              <div className="d-flex flex-row h-100 my-auto">
                <DashboardIcon />
                <span className="sidenav-item-text ms-2">Dashboard</span>
              </div>
            </Link>
          )}
          <Link
            to={userType === 'ADMIN' ? "/admin/scheme" : "/partner/scheme"}
            className={
              "nav-link sidenav-item text-white fs-large-regular text-start w-100 " +
              (userType === "ADMIN"
                ? location.pathname === "/admin/scheme" ||
                  location.pathname === "/admin/scheme/investor" ||
                  location.pathname === "/admin/scheme/description"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular"
                : location.pathname === "/partner/scheme" ||
                  location.pathname === "/partner/scheme/investor" ||
                  location.pathname === "/partner/scheme/description"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular")
            }
            type="button"
            role="tab"
            aria-selected="false"
          >
            <div className="d-flex flex-row h-100 my-auto">
              <FormatListBulletedRoundedIcon />
              <span className="sidenav-item-text ms-2">Scheme</span>
            </div>
          </Link>

          <Link
            to={userType === 'ADMIN' ? "/admin/fund" : "/partner/fund"}
            className={
              "nav-link sidenav-item text-white fs-large-regular text-start w-100 " +
              (userType === 'ADMIN'
                ?
                location.pathname === "/admin/fund"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular"
                : location.pathname === "/partner/fund"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular"
              )
            }
            type="button"
            role="tab"
            aria-selected="false"
          >
            <div className="d-flex flex-row h-100 my-auto">
              <AccountBalanceWalletRoundedIcon />
              <span className="sidenav-item-text ms-2">Fund Master</span>
            </div>
          </Link>


          {userType === "ADMIN" && (
            <Link
              to="/admin/unit-transfer"
              className={
                "nav-link sidenav-item text-white fs-large-regular text-start w-100 " +
                (location.pathname === "/admin/unit-transfer"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular")
              }
              type="button"
              role="tab"
              aria-selected="false"
            >
              <div className="d-flex flex-row h-100 my-auto">
                <SwapHorizRoundedIcon />
                <span className="sidenav-item-text ms-2">Unit Transfer</span>
              </div>
            </Link>
          )}
          <Link
            to={userType === 'ADMIN' ? "/admin/investors" : "/partner/investors"}
            className={
              "nav-link sidenav-item text-white fs-large-regular text-start w-100 " +
              (userType === 'ADMIN'
                ?
                location.pathname === "/admin/investors"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular"
                :
                location.pathname === "/partner/investors"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular"
              )
            }
            type="button"
            role="tab"
            aria-selected="false"
          >
            <div className="d-flex flex-row h-100 my-auto">
              <GroupsRoundedIcon />
              <span className="sidenav-item-text ms-2">Investors</span>
            </div>
          </Link>
          {userType === "ADMIN" && (
            <Link
              to={{ pathname: "/admin/investor-voting-list" }}
              className={
                "nav-link sidenav-item text-white fs-large-regular text-start " +
                (location.pathname === "/admin/investor-voting-list"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular")
              }
              type="button"
              role="tab"
              aria-selected="false"
            >
              <div className="d-flex flex-row h-100 my-auto">
                <HowToVoteIcon />
                <span className="sidenav-item-text ms-2">Investor Voting</span>
              </div>
            </Link>
          )}
          {userType === "ADMIN" && (
            <Link
              to="/admin/partners"
              className={
                "nav-link sidenav-item text-white fs-large-regular text-start w-100 " +
                (location.pathname === "/admin/partners"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular")
              }
              type="button"
              role="tab"
              aria-selected="false"
            >
              <div className="d-flex flex-row h-100 my-auto">
                <HandshakeIcon />
                <span className="sidenav-item-text ms-2">Partners</span>
              </div>
            </Link>
          )}
          <Link
            to={userType === 'ADMIN' ? "/admin/demat-master" : "/partner/demat-master"}
            className={
              "nav-link sidenav-item text-white fs-large-regular text-start w-100 " +
              (userType === "ADMIN"
                ? location.pathname === "/admin/demat-master"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular"
                : location.pathname === "/partner/demat-master"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular")
            }
            type="button"
            role="tab"
            aria-selected="false"
          >
            <div className="d-flex flex-row h-100 my-auto">
              <TableViewIcon />
              <span className="sidenav-item-text ms-2">Demat</span>
            </div>
          </Link>
          {userType === "ADMIN" && (
            <Link
              to="/admin/portfolio"
              className={
                "nav-link sidenav-item text-white fs-large-regular text-start w-100 " +
                (location.pathname === "/admin/portfolio"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular")
              }
              type="button"
              role="tab"
              aria-selected="false"
            >
              <div className="d-flex flex-row h-100 my-auto">
                <AutoGraphRoundedIcon />
                <span className="sidenav-item-text ms-2">
                  Sprint Portfolio
                </span>
              </div>
            </Link>
          )}
          {userType === "ADMIN" && (
            <Link
              to="/admin/class"
              className={
                "nav-link sidenav-item text-white fs-large-regular text-start w-100 " +
                (location.pathname === "/admin/class"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular")
              }
              type="button"
              role="tab"
              aria-selected="false"
            >
              <div className="d-flex flex-row h-100 my-auto">
                <SegmentRoundedIcon />
                <span className="sidenav-item-text ms-2">Class</span>
              </div>
            </Link>
          )}
          {userType === "ADMIN" && (
            <Link
              to="/admin/company"
              className={
                "nav-link sidenav-item text-white fs-large-regular text-start w-100 " +
                (location.pathname === "/admin/company"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular")
              }
              type="button"
              role="tab"
              aria-selected="false"
            >
              <div className="d-flex flex-row h-100 my-auto">
                <BusinessRoundedIcon />
                <span className="sidenav-item-text ms-2">Company</span>
              </div>
            </Link>
          )}
          {userType === "ADMIN" && (
            <Link
              to="/admin/company-updates"
              className={
                "nav-link sidenav-item text-white fs-large-regular text-start w-100 " +
                (location.pathname === "/admin/company-updates"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular")
              }
              type="button"
              role="tab"
              aria-selected="false"
            >
              <div className="d-flex flex-row h-100 my-auto">
                <UpdateRoundedIcon />
                <span className="sidenav-item-text ms-2">Com. Updates</span>
              </div>
            </Link>
          )}
          {userType === "ADMIN" && (
            <Link
              to="/admin/massInvestorMailer"
              className={
                "nav-link sidenav-item text-white fs-large-regular text-start w-100 " +
                (location.pathname === "/admin/massInvestorMailer"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular")
              }
              type="button"
              role="tab"
              aria-selected="false"
            >
              <div className="d-flex flex-row h-100 my-auto">
                <EmailIcon />
                <span className="sidenav-item-text ms-2">Mass Investor Mailer</span>
              </div>
            </Link>
          )}
          {userType === "ADMIN" && (
            <Link
              to="/admin/queries"
              className={
                "nav-link sidenav-item text-white fs-large-regular text-start w-100 " +
                (location.pathname === "/admin/queries"
                  ? "active text-dark fs-large-semibold"
                  : "fs-large-regular")
              }
              type="button"
              role="tab"
              aria-selected="false"
            >
              <div className="d-flex flex-row h-100 my-auto">
                <ContactSupportRoundedIcon />
                <span className="sidenav-item-text ms-2">Queries</span>
              </div>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default SideBar;